<script lang="ts">
	import { DataHandlerDeviceAdmin } from "luxedo-data"
	import Header from "../../../reusable/Header.svelte"
	import { onMount } from "svelte"
	import DeviceInfo from "./DeviceInfo.svelte"
	import { LuxedoRPC } from "luxedo-rpc"
	import type { DeviceAdmin } from "luxedo-data/src/entries/admin/DeviceAdmin"
	import TrackedCalList from "./TrackedCalList.svelte"
	import type { BundledCalibrationData } from "luxedo-rpc/src/types/BundledTypes"
	import { openImageOverlay } from "overlay"

	let device: DeviceAdmin = $state()
	let calibrations: Array<BundledCalibrationData> = $state()

	let { params } = $props()

	async function updateTrackedCals() {
		if (device?.trackedCalIDs?.length > 0) {
			const data = await LuxedoRPC.api.admin.tracked_cali_bundle_down(
				device.trackedCalIDs
			)
			calibrations = Object.values(data)
		} else calibrations = []
	}

	async function updateViewDevice() {
		if (!params.id) return
		const deviceID = params.id
		await DataHandlerDeviceAdmin.pull([deviceID])
		device = DataHandlerDeviceAdmin.get(deviceID)
		updateTrackedCals()
	}

	function viewSnapshots() {
		openImageOverlay(device.snapshots, {
			heading: "Snapshots",
		})
	}

	onMount(async () => {
		await updateViewDevice()
	})
</script>

{#if device}
	<Header heading={device.name} />
	<div id="action-container" class="button-container">
		{#if device.snapshots?.length > 0}
			<button id="snapshots-indicator" class="small" onclick={viewSnapshots}
				>View Snapshots</button
			>
		{:else}
			<span id="snapshots-indicator" class="alert">No Snapshots</span>
		{/if}
	</div>
	<div class="flex-wrap">
		<DeviceInfo {device} />
		<TrackedCalList trackedCals={calibrations} {updateTrackedCals} />
	</div>
{/if}

<style>
	#action-container {
		width: fit-content;
		position: absolute;
		top: 1rem;
		right: 1rem;
		height: 2rem;
	}

	#action-container > button:last-of-type {
		margin-left: 1rem;
	}
</style>
